// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "01da5d7b236477c8c865" + ".js";
};